export const SETTINGS = [
  {
    apiName: "settings",
    component: "FrmBarcodeSettings",
  },
];
